import { ITemple } from 'pages/apps/Temple/types';
import { TempleActionTypes } from './constants';

export type TempleActionType = {
    type:
        | TempleActionTypes.API_RESPONSE_SUCCESS
        | TempleActionTypes.API_RESPONSE_ERROR
        | TempleActionTypes.GET_TEMPLES
        | TempleActionTypes.ADD_TEMPLE
        | TempleActionTypes.DELETE_TEMPLE
        | TempleActionTypes.GET_TEMPLE_DETAILS
        | TempleActionTypes.UPDATE_TEMPLE
        | TempleActionTypes.RESET;

    payload: {} | string;
};

// common success
export const templeApiResponseSuccess = (actionType: string, data: ITemple[] | {}): TempleActionType => ({
    type: TempleActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// common error
export const templeApiResponseError = (actionType: string, error: string): TempleActionType => ({
    type: TempleActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getTemples = (params: any): TempleActionType => ({
    type: TempleActionTypes.GET_TEMPLES,
    payload: params,
});

// Add temple
export const addTemple = (params: any): TempleActionType => ({
    type: TempleActionTypes.ADD_TEMPLE,
    payload: params,
});

export const getTempleByIdAction = (templeId: number): TempleActionType => ({
    type: TempleActionTypes.GET_TEMPLE_DETAILS,
    payload: { templeId },
});

export const updateTempleByIdAction = (templeData: any): TempleActionType => ({
    type: TempleActionTypes.UPDATE_TEMPLE,
    payload: templeData,
});

export const deleteTempleByIdAction = (templeId: number) => ({
    type: TempleActionTypes.DELETE_TEMPLE,
    payload: templeId,
});

export const resetTempleState = (): TempleActionType => ({
    type: TempleActionTypes.RESET,
    payload: {},
});
